module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "3.2em",
      "background": "#ffffff"
    },
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "section"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container is-wide"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _vm._e()]) : _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {}, [(_vm.product_display_image && (_vm.product_display_image.product_image != '' && _vm.product_display_image.product_image != 'error')) ? _c('img', {
    staticClass: "pb_img",
    attrs: {
      "src": _vm.img_product_url + _vm.product_display_image.product_image,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "pb_img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', {
    staticClass: "img-row",
    staticStyle: {
      "margin-top": "-4em"
    }
  }, _vm._l((_vm.product.product_images), function(img) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-display-image', img)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    })])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "4px"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sp-prd-attr-block",
    staticStyle: {
      "width": "100%",
      "margin-top": "2em"
    }
  }, [_c('table', {
    staticClass: "tb-cols",
    staticStyle: {
      "width": "100%",
      "margin": "0"
    }
  }, [_c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right",
    staticStyle: {
      "padding": "5px"
    }
  }, [(_vm.product_item.product_item_actual_price != 0) ? _c('p', {
    staticClass: "attr-intro-desc prd-price prd-discounted-price"
  }, [_c('del', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price_f))])]) : _c('p', {
    staticClass: "attr-intro-desc prd-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price_f))])])])]), _vm._v(" "), (_vm.product_item.product_item_actual_price != 0) ? _c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right col-xs-8",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('p', {
    staticClass: "attr-intro-desc prd-discount-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price_f))])])])]) : _vm._e(), _vm._v(" "), (((_vm.product.product_set_groups != 0))) ? _c('tr', [_c('td', {
    staticClass: "td-col-2"
  }, [(((_vm.product.product_set_groups != 0))) ? _c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Select: ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right"
  }, [_c('table', [_c('tr', _vm._l((_vm.product.product_item_groups), function(pg) {
    return _c('td', {
      staticStyle: {
        "padding-right": "2px"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item-group', pg)
        }
      }
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('span', {
      staticClass: "product-item-group box-cube",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticStyle: {
        "width": "45px",
        "height": "45px"
      },
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "width": "45px",
        "height": "45px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    }), _c('br')]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('span', {}, [_c('span', {
      staticClass: "product-item-group box-color-cube",
      style: ({
        background: pg.product_item_group_color
      }),
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.product.product_item_groups.length > 1) ? _c('span', {
      staticStyle: {
        "font-size": "8px"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))]) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_group_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-1em",
      "padding-top": "1em",
      "float": "left",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_group_message))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (((_vm.product_item_group.product_items) && (_vm.product_item_group.product_items.length != 0))) ? _c('tr', {
    staticStyle: {
      "clear": "both"
    }
  }) : _vm._e(), (((_vm.product.product_set_items != 0) && (_vm.product.product_set_items_params_check != 0))) ? _c('tr', [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right"
  }, [_c('ul', {
    staticClass: "prd-color-block",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, _vm._l((_vm.product_item_group.product_items), function(pt) {
    return _c('li', {
      staticClass: "items-list-tiny listnone"
    }, [_c('span', {
      staticClass: "product-item listnone",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'P') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "product-item listnone",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'S') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_item_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-0.1em",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_item_message))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('p', {
    staticClass: "attr-intro-desc"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_weight) + " (Kg)")])])])]), _vm._v(" "), (_vm.is_product_in_cart) ? _c('tr', {
    staticStyle: {
      "border": "dotted 1px #96c5f5",
      "padding": "5px 2px"
    }
  }, [_c('td', {
    staticClass: "td-col-10"
  }, [_c('p', [_vm._v("This Item is in your cart \r\n                      "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "width": "12em",
      "cursor": "pointer",
      "line-height": "1.8"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])])])]) : _c('tr', [_vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right",
    staticStyle: {
      "margin": "-1em 5px"
    }
  }, [_c('div', {}, [_c('a', {
    staticClass: "col-xs-2 qty-btn qty-btn-sm",
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "none",
      "padding": "0"
    },
    on: {
      "click": function($event) {
        _vm.removeQuantity(_vm.product_item.product_item_order_quantity)
      }
    }
  }, [_vm._v("–")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_order_quantity),
      expression: "product_item.product_item_order_quantity"
    }],
    key: _vm.product_item_quantity_key,
    staticClass: "col-xs-4 qty-input qty-input-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_item.product_item_order_quantity)
    },
    on: {
      "change": function($event) {
        _vm.checkOrderQuantity(_vm.product_item.product_item_order_quantity)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_order_quantity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "col-xs-2 qty-btn qty-btn-sm",
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "none",
      "padding": "0"
    },
    on: {
      "click": function($event) {
        _vm.addQuantity(_vm.product_item.product_item_order_quantity)
      }
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.check_order_quantity))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [(_vm.product_item.product_item_quantity > 0) ? _c('ul', {
    staticStyle: {
      "clear": "both",
      "padding-left": "0"
    }
  }, [(_vm.data_cart_message) ? _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.data_cart_message))]) : _vm._e(), _vm._v(" "), (!_vm.product_is_ready_to_cart) ? _c('div', [_c('ul', {
    staticClass: "cart-wrap"
  }, [_c('li', {
    staticClass: "col-xs-6",
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, [_c('button', {
    staticClass: "cta-btn",
    on: {
      "click": _vm.prep_set_product_is_ready_to_cart
    }
  }, [_vm._v(" Buy Now")])]), _vm._v(" "), _c('li', {
    staticClass: "col-xs-6",
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, [_c('button', {
    staticClass: "cart-btn",
    on: {
      "click": _vm.prep_set_product_is_ready_to_cart
    }
  }, [_vm._v(" Add to Cart")])])])]) : _c('div', [_c('ul', {
    staticClass: "cart-wrap"
  }, [_c('li', {
    staticClass: "col-xs-6",
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, [_c('product-cta-button', {
    attrs: {
      "productMain": _vm.product,
      "productItemGroup": _vm.product_item_group,
      "productItem": _vm.product_item
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "col-xs-6",
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, [_c('add-to-cart-button', {
    attrs: {
      "productMain": _vm.product,
      "productItemGroup": _vm.product_item_group,
      "productItem": _vm.product_item
    }
  })], 1)])])]) : _c('ul', {
    staticClass: "col-xs-12 row"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#ff0000"
    }
  }, [_vm._v("This Item is out of Stock")])])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "info-blocks"
  }, [(_vm.product.product_business_delivery_options.length > 0) ? _c('div', {
    staticClass: "info-block col-md-12 col-xs-12",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "info-right-2 col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "prd-delivery-list"
  }, _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦\r\n                          "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(_vm._s(fee.product_delivery_fee) + "\r\n                              ")]) : _vm._e()])
    })) : _c('span', [_vm._v("\r\n                            " + _vm._s(delivery.business_delivery_option_price) + "\r\n                          ")])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mshare",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('ul', {}, [_c('li', [_vm._v("Share:")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "share-btn",
    attrs: {
      "href": 'https://www.facebook.com/sharer/sharer.php?u=' + _vm.share_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "share-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Copy Link. Paste and Share Anywhere"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_vm._v("Copy Link\r\n                        ")]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    }
  }, [_vm._v("Copied")]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('a', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('descr')
      }
    }
  }, [(_vm.tab_view.descr) ? _c('div', [_c('u', {
    staticStyle: {
      "border-bottom": "#061433 solid 1px"
    }
  }, [_vm._v("Description")])]) : _c('div', [_vm._v("Description")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('info')
      }
    }
  }, [(_vm.tab_view.info) ? _c('div', [_c('u', {
    staticStyle: {
      "border-bottom": "#061433 solid 1px"
    }
  }, [_vm._v("More Details")])]) : _c('div', [_vm._v("More Details")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('reviews')
      }
    }
  }, [(_vm.tab_view.reviews) ? _c('div', [_c('u', {
    staticStyle: {
      "border-bottom": "#061433 solid 1px"
    }
  }, [_vm._v("Reviews (2)")])]) : _c('div', [_vm._v("Reviews (2)")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "2em 1em"
    }
  }, [(_vm.tab_view.descr) ? _c('div', [_c('div', {
    staticClass: "w-richtext"
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v(_vm._s(_vm.product.product_description) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.tab_view.info) ? _c('div', [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.tab_view.reviews) ? _c('div', [_c('p', [_vm._v("Reviews and Comments")])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(11), _vm._v(" "), _vm._l((_vm.related_products), function(product, rpdex) {
    return _c('div', {
      staticClass: "col-xs-6"
    }, [_c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('div', [_c('div', {}, [_c('a', {
      attrs: {
        "href": '/' + product.product_business_username + '/' + product.product_url_name
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "pimage",
      attrs: {
        "src": product.product_images[0].product_image,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "pimage",
      attrs: {
        "src": "https://via.placeholder.com/1000x600.png?text=IMAGE 560w",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {}, [(product.product_category_name != 'error') ? _c('a', {
      staticStyle: {
        "font-size": "10px"
      },
      attrs: {
        "href": "'/'+product.product_business_ownername+'/'+product.product_url_name"
      }
    }, [_vm._v(_vm._s(product.product_category_name))]) : _vm._e()]), _vm._v(" "), _vm._m(12, true), _vm._v(" "), _c('a', {
      staticClass: "w-inline-block",
      attrs: {
        "href": '/' + product.product_business_username + '/' + product.product_url_name
      }
    }, [_c('div', {}, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price) + " \r\n                        "), _c('del', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price))])]) : _vm._e()])])])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "-1em"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#ffd900"
    }
  }, [_c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-blank"
  }, [_vm._v("")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Price: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Discount Price: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Select: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Weight: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Quantity:  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h6', [_vm._v("PRODUCT DELIVERY LOCATIONS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-extrainfo",
    staticStyle: {
      "margin-top": "2em",
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "c-extrainfo__text w-inline-block",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "fa margin-right-small"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "text-xsmall"
  }, [_vm._v("Store availability")])]), _vm._v(" "), _c('a', {
    staticClass: "c-extrainfo__text w-inline-block",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "fa margin-right-small"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "text-xsmall"
  }, [_vm._v("Delivery and return")])]), _vm._v(" "), _c('a', {
    staticClass: "c-extrainfo__text w-inline-block",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "fa margin-right-small"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "text-xsmall"
  }, [_vm._v("Ask a question")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('a', {
    staticClass: "share-btn",
    staticStyle: {
      "text-decoration": "none",
      "font-size": "14px"
    },
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-heart",
    staticStyle: {
      "color": "#ff0000"
    }
  })]), _vm._v(" Add to wishlist\r\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "share-btn",
    attrs: {
      "href": "'https://twitter.com/intent/tweet?source='+share_url+'&text='+share_text"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-layout-grid c-grid-info"
  }, [_c('p', [_vm._v("More Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Related products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#ffd900"
    }
  }, [_c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-blank"
  }, [_vm._v("")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dfd1c78"}!./src/pages/AppWebnShop/Order/template.html
// module id = 436
// module chunks = 0